import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=936d8d90&scoped=true"
import script from "./Answers.vue?vue&type=script&lang=js"
export * from "./Answers.vue?vue&type=script&lang=js"
import style0 from "./Answers.vue?vue&type=style&index=0&id=936d8d90&prod&lang=scss&scoped=true"
import style1 from "./Answers.vue?vue&type=style&index=1&id=936d8d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d8d90",
  null
  
)

export default component.exports